import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function ContactIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_12371_103051" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40"><rect width="40" height="40" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_12371_103051)"><path d="M13.334 23.3333H26.6673V22.5417C26.6673 21.375 26.077 20.4722 24.8965 19.8333C23.7159 19.1945 22.084 18.875 20.0007 18.875C17.9173 18.875 16.2854 19.1945 15.1048 19.8333C13.9243 20.4722 13.334 21.375 13.334 22.5417V23.3333ZM20.0007 16.125C20.8484 16.125 21.5743 15.8231 22.1782 15.2192C22.782 14.6156 23.084 13.8897 23.084 13.0417C23.084 12.1936 22.782 11.4678 22.1782 10.8642C21.5743 10.2603 20.8484 9.95834 20.0007 9.95834C19.1529 9.95834 18.427 10.2603 17.8231 10.8642C17.2193 11.4678 16.9173 12.1936 16.9173 13.0417C16.9173 13.8897 17.2193 14.6156 17.8231 15.2192C18.427 15.8231 19.1529 16.125 20.0007 16.125ZM3.33398 36.6667V5.83334C3.33398 5.16668 3.58398 4.58334 4.08398 4.08334C4.58398 3.58334 5.16732 3.33334 5.83398 3.33334H34.1673C34.834 3.33334 35.4173 3.58334 35.9173 4.08334C36.4173 4.58334 36.6673 5.16668 36.6673 5.83334V27.5C36.6673 28.1667 36.4173 28.75 35.9173 29.25C35.4173 29.75 34.834 30 34.1673 30H10.0007L3.33398 36.6667ZM8.91732 27.5H34.1673V5.83334H5.83398V30.8333L8.91732 27.5Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}